module.exports = __webpack_public_path__ + "img/cohorts.fb08955a.svg";